/**
 * versandort — display helpers for addresses from `vendor_addresses`.
 *
 * The ship-from RULE is the backend's alone (`backend/lieferant_versandort.py`,
 * Owner 2026-09-26: the active pickup, else the active warehouse, else the
 * active headquarters; two active rows of the chosen type are a conflict; a
 * chosen row lacking a required field is incomplete). The "Addresses" section
 * shows the server's answer (`versandort` in `GET /api/vendors/:id/addresses`)
 * instead of computing it here.
 *
 * 🔴 Until the Regel-15/16-Tore on Stufe b (2026-09-26) this file carried a
 * mirror of the order (`REIHENFOLGE`, `versandortAus`). It knew the order but
 * not the required fields, so an incomplete row got the green "Ship-from"
 * marker that the AVIS then rejected. Two lists that must agree are the
 * defect; the mirror is gone, and `backend/tests/test_lieferant_versandort.py::
 * test_die_oberflaeche_fuehrt_die_regel_nicht_ein_zweites_mal` keeps it gone.
 */

import { landEtikett } from './laender'

/** `"name1, strasse, plz ort, Country (CC)"` without empty parts; `''` without
 *  a row. Same parts as `lieferant_versandort.firmensitz_einzeiler`; the
 *  country reads as the cards in the "Addresses" section show it
 *  (`landEtikett`, UX-Tor zu Stufe b, W4: one spelling across the surfaces). */
export function anschriftEinzeiler(a) {
  if (!a) return ''
  const t = (x) => String(x || '').trim()
  const plzOrt = [t(a.plz), t(a.ort)].filter(Boolean).join(' ')
  const land = t(a.land) ? landEtikett(t(a.land)) : ''
  return [t(a.name1), t(a.strasse), plzOrt, land].filter(Boolean).join(', ')
}
